import { render, staticRenderFns } from "./YearIndexAddView.vue?vue&type=template&id=feec8236&scoped=true&"
import script from "./YearIndexAddView.vue?vue&type=script&lang=js&"
export * from "./YearIndexAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec8236",
  null
  
)

export default component.exports